import Input, { InputProps } from "./Input"
import { SearchIcon } from '@heroicons/react/solid';
import { useState } from "react";

interface SearchProps extends InputProps {
  handleSearch?: (value: string) => void; // 点击搜索图标、清除图标，或按下回车键时的回调
}
const Search: React.FC<SearchProps> = ({ handleSearch, defaultValue, ...props }) => {
  const [inputValue, setInputValue] = useState(defaultValue || '')
  const onSearch = (
    event: React.MouseEvent<SVGSVGElement> | React.KeyboardEvent<HTMLInputElement>, // 回车事件 e.target.value
    value?: string // 点击事件 得到 value
  ) => {
    handleSearch?.((event.target as HTMLInputElement).value || value! || '')
  }
  return (
    <Input
      suffix={
        <SearchIcon className="w-5 text-gray-600 cursor-pointer"
          onClick={(e: React.MouseEvent<SVGSVGElement>) => onSearch(e, inputValue)}
        />
      }
      clear
      handleChange={e => setInputValue(e.target.value)}
      handlePressEnter={onSearch}
      {...props}
    ></Input>
  )
}
export default Search